import { Modal } from 'antd';
import useDialog from '../../../../1_application/core/components/feedback/useDialog';
import { ReactComponent as Close } from '../../../../assets/icons/closeBlack.svg';

const LXDialog = () => {
  const { isOpen, closeDialog, child } = useDialog();

  if (isOpen)
    return (
      <Modal
        open={isOpen}
        onCancel={closeDialog}
        closeIcon={<Close></Close>}
        centered={true}
        footer={null}
        width={'none'}
      >
        {child}
      </Modal>
    );
  else return <></>;
};

export default LXDialog;
